var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916504 3.41675C0.916504 2.03604 2.03579 0.916748 3.4165 0.916748H11.7498C13.1305 0.916748 14.2498 2.03604 14.2498 3.41675V11.7501C14.2498 13.1308 13.1305 14.2501 11.7498 14.2501H3.4165C2.03579 14.2501 0.916504 13.1308 0.916504 11.7501V3.41675Z",
    stroke: "#F9FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08317 8.41675L9.24984 4.25008L10.9165 5.91675L6.74984 10.0834L4.24984 10.9167L5.08317 8.41675Z",
    stroke: "#F9FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBoxIcon);
export default __webpack_public_path__ + "static/media/editBoxIcon.8e8138fb270f845a6f87c29ac6fef65b.svg";
export { ForwardRef as ReactComponent };